// Vendor
import { createClient, type CreateClientParams } from "contentful";

// Constants
import { CONTENTFUL_SPACE_NAME } from "@citizenm/foundation/shared/types/contentful/constants";

// Types
import type { ContentfulSpaceName } from "@citizenm/foundation/shared/types/contentful";

/**
 *
 * @deprecated This Contentful client should be dropped in favor of the one in the Foundation package. For the new remember space, use the client from the Contentful package
 */
export function createContentfulClient(
  space: ContentfulSpaceName = CONTENTFUL_SPACE_NAME.product,
  preview = false,
) {
  const { public: publicConfig } = useRuntimeConfig();

  const {
    // product
    ctfSpaceId,
    ctfEnvironment,
    ctfCdaAccessToken,
    ctfCdaPreviewToken,
    // marketing
    ctfMarketingSpaceId,
    ctfMarketingEnvironment,
    ctfMarketingCdaAccessToken,
    ctfMarketingCdaPreviewToken,
  } = publicConfig;

  if (
    // product
    !ctfSpaceId ||
    !ctfEnvironment ||
    !ctfCdaAccessToken ||
    !ctfCdaPreviewToken ||
    // marketing
    !ctfMarketingSpaceId ||
    !ctfMarketingEnvironment ||
    !ctfMarketingCdaAccessToken
  ) {
    throw new Error(
      "Contentful client is not initialized. Some env variables are missing.",
    );
  }

  const config: CreateClientParams =
    space === CONTENTFUL_SPACE_NAME.marketing
      ? // marketing config
        {
          accessToken: preview
            ? ctfMarketingCdaPreviewToken
            : ctfMarketingCdaAccessToken,
          environment: ctfMarketingEnvironment,
          headers: {
            "x-contentful-resource-resolution": btoa(
              JSON.stringify({
                spaces: {
                  [ctfSpaceId]: preview
                    ? ctfCdaPreviewToken
                    : ctfCdaAccessToken,
                },
              }),
            ),
          },
          host: `${preview ? "preview" : "cdn"}.contentful.com`,
          space: ctfMarketingSpaceId,
        }
      : // product config
        {
          accessToken: ctfCdaAccessToken,
          environment: ctfEnvironment,
          space: ctfSpaceId,
        };

  return createClient(config);
}
